module.exports = __webpack_public_path__ + "static/media/container12.46d1df72.jpg";